<template>
	<div>
		<van-sticky>
			<navbar :title="title" />
			<van-search v-model="list.search" placeholder="请输入搜索关键词" @search="onSearch"></van-search>
		</van-sticky>
		<van-list
			v-model="list.loading"
			:finished="list.finished"
			finished-text="没有更多了"
			@load="onLoad"
			style="padding-bottom: 50px;"
		>
			<van-swipe-cell v-for="item in list.customer" :key="item.client_id">
				<van-cell @click="clientDetails(item.client_id)">
					<div class="user-title">
						<span class="user-title-name" style="font-weight: 600;">
							<van-icon name="friends-o" />
							{{item.client_name}}
						</span>
						<span
							class="user-title-date"
							style="float: right; font-size: 12px;"
						>{{item.create_date.slice(0, 10)}}</span>
					</div>
					<div class>
						<van-icon name="phone-o" />
						{{item.contact_phone}}
					</div>
				</van-cell>
				<template #right>
					<van-button
						square
						@click="discard(item.client_id)"
						class="swipe-button"
						type="danger"
						text="丢弃"
					/>
					<van-button
						square
						@click="follow(item.client_id, item.client_status)"
						class="swipe-button"
						type="primary"
						text="跟进"
					/>
				</template>
			</van-swipe-cell>
		</van-list>
		<van-tabbar v-model="activeName">
			<van-tabbar-item name="list" icon="user-o" to="/customer/list">我的客户</van-tabbar-item>
			<van-tabbar-item name="public" icon="friends-o" to="/customer/publicList">公共客户</van-tabbar-item>
			<van-tabbar-item name="index" icon="add-o" to="/customer">新增客户</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { getList, discard } from "@/api/customer";
import { Toast } from "vant";

export default {
	name: "customer",
	components: {
		navbar
	},
	data() {
		return {
			title: "我的客户",
			activeName: "list",
			list: {
				customer: [],
				loading: false,
				finished: false,
				page: 1,
				limit: 10,
				search: ""
			}
		};
	},
	activated() {
		if (this.$route.params.refresh != true) {
			this.list.list = [];
			this.activeName = "list";
			this.list.finished = false;
			this.list.page = 1;
			this.list.search = "";
			this.onLoad();
		}
	},
	methods: {
		onSearch() {
			this.list.finished = false;
			this.list.page = 1;
			this.onLoad();
		},
		onLoad() {
			let axiosData = new Object();
			axiosData.requestType = "get_private_client";
			axiosData.page = this.list.page;
			axiosData.limit = this.list.limit;
			axiosData.search = this.list.search;

			getList(axiosData)
				.then(response => {
					if (response.obj.rows.length === 0) {
						this.list.finished = true;
					}
					if (this.list.page != 1) {
						this.list.customer = this.list.customer.concat(
							response.obj.rows
						);
					} else {
						this.list.customer = response.obj.rows;
					}

					this.list.page += 1;
					this.list.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.list.loading = false;
					this.list.finished = true;
					return Toast("数据异常");
				});
		},
		clientDetails(id) {
			this.$router.push({
				path: "/customer/details",
				query: {
					id: id
				}
			});
		},
		discard(id) {
			discard({
				requestType: "private_client_discard",
				client_id: id
			})
				.then(() => {
					this.list.page = 1;
					this.onLoad();
					Toast.success("丢弃客户成功!");
				})
				.catch(err => {
					console.log(err);
					return Toast("数据异常");
				});
		},
		follow(id, client_status) {
			this.$router.push({
				path: "/customer/follow",
				query: {
					id: id,
					client_status: client_status
				}
			});
		}
	}
};
</script>

<style scoped>
.swipe-button {
	height: 100%;
}
</style>
